<template>
  <div>
    <el-collapse  v-model="activeNames">
      <el-collapse-item title="柱体样式" name="1">
        <div>
          <p>柱体最小高度</p>
          <slider-and-input :value.sync="minHeight" suffix="px" />
        </div>
        <div class="mt8">
          <p>柱体粗细</p>
          <slider-and-input :value.sync="barSize" suffix="px" />
        </div>
        <div class="mt8">
          <p>柱体圆润度</p>
          <slider-and-input :value.sync="bevelSmoothness" suffix="px"/>
        </div>
        <p class="mt8">柱体颜色</p>
        <color-picker :color.sync="barColor" class="mt8 colorchoose"></color-picker>
        <p class="mt8">动画时间</p>
        <slider-and-input :value.sync="animationDurationUpdate" suffix="秒" />
        <!-- <div>
          <p>动画时间</p>
          <slider-and-input :value.sync=""/>
        </div> -->
      </el-collapse-item>
      <el-collapse-item name="2" title="标签">
        <div>
          <cx-check-box :value.sync="showLabel">显示标签文字</cx-check-box>
          <div v-show="showLabel">
            <p class="mt8">位置纵向偏移</p>
            <slider-and-input :value.sync="distance"></slider-and-input>
            <label class="mt16 font14 inlineMiddle">文字样式 </label>
            <text-setting-update
              class="mt8"
              :fontColor.sync="labelFontColor"
              :fontFamily.sync="labelFontFamily"
              :fontSize.sync="labelFontSize"
              :fontWeight.sync="labelFontWeight"
            />
          </div>
        </div>
        
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import areaLabel from "../../../map/toolbars/mapSettings/areaLabel"
export default {
  components: {
    areaLabel
  },
  props: {
    options: Object
  },
  data() {
    return {
      activeNames: ["1", "2"]
    }
  },
  computed: {
    chartOption() {
      return this.options.chartOption
    },
    barColor: {
      get() {
        return this.chartOption.bar.itemStyle.color
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.bar.itemStyle.color", false)
      }
    },
    barSize: {
      get() {
        return this.chartOption.bar.barSize
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.bar.barSize", false)
      }
    },
    minHeight: {
      get() {
        return this.chartOption.bar.minHeight
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.bar.minHeight", false)
      }
    },
    bevelSize: {
      get() {
        return this.chartOption.bar.bevelSize
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.bar.bevelSize", false)
      }
    },
    animationDurationUpdate: {
      get() {
        return this.chartOption.bar.animationDurationUpdate / 1000
      },
      set(val) {
        this.$changeOptionsEV(val * 1000, "chartOption.bar.animationDurationUpdate", false)
      }
    },
    bevelSmoothness: {
      get() {
        return this.chartOption.bar.bevelSmoothness
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.bar.bevelSmoothness", false)
      }
    },
    showLabel: {
      get() {
        return this.chartOption.bar.label.show
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.bar.label.show", false)
      }
    },
    distance: {
      get() {
        return this.chartOption.bar.label.distance
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.bar.label.distance", false)
      }
    },
    labelFontColor: {
      get() {
        return this.chartOption.bar.label.color
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.bar.label.color", false)
      }
    },
    labelFontFamily: {
      get() {
        return this.chartOption.bar.label.fontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.bar.label.fontFamily", false)
      }
    },
    labelFontSize: {
      get() {
        return this.chartOption.bar.label.fontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.bar.label.fontSize", false)
      }
    },
    labelFontWeight: {
      get() {
        return this.chartOption.bar.label.fontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.bar.label.fontWeight", false)
      }
    }
  }
}
</script>
<style scoped>
</style>
